import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal } from 'react-bootstrap';
import { Button } from '@sumologic/yama-ds-components';

import Table2 from '~/components/Table2/Table2';
import Translate from '~/components/Translate/Translate';
import HeaderModal from '~/components/HeaderModal/HeaderModal';
import { IncidentLink } from '~/components/OperationCard/OperationCard';

function InvolvedIncidents(props) {
    const { show, onHide, involvedIncidents } = props;

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            scrollable
            size="md-lg"
            id="modal-involved-incidents"
        >
            <HeaderModal
                title={<Translate message="Involved incidents" />}
                onHide={onHide}
                description={
                    <div className="description d-flex align-items-center">
                        {involvedIncidents.count}{' '}
                        <Translate message={'Match'} />
                    </div>
                }
                icon={'shield-check2'}
            />
            <Modal.Body>
                <Row className="mx-1 h-100">
                    <Col className="p-0">
                        <Table2
                            suppressRowClickSelection
                            rows={involvedIncidents.details}
                            columnDefs={[
                                {
                                    field: 'name',
                                    headerName: 'Incident ID',
                                    cellRenderer: 'incidentLink'
                                },
                                {
                                    field: 'status',
                                    headerName: 'Status'
                                },
                                {
                                    field: 'type',
                                    headerName: 'Type'
                                }
                            ]}
                            cellRenders={{
                                incidentLink: params => {
                                    return (
                                        <IncidentLink
                                            incident={{
                                                id: params.data.id,
                                                name: params.data.name
                                            }}
                                            onClick={() => {
                                                onHide();
                                            }}
                                        />
                                    );
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="text"
                    color="primary"
                    onClick={e => {
                        e.preventDefault();
                        onHide();
                    }}
                >
                    <Translate message="Close" />
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

InvolvedIncidents.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    involvedIncidents: PropTypes.object
};

InvolvedIncidents.defaultProps = {};

export default InvolvedIncidents;
